import { render, staticRenderFns } from "./tracking.vue?vue&type=template&id=1a7447ea&"
import script from "./tracking.vue?vue&type=script&lang=js&"
export * from "./tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports